import React from 'react';
import { FiClock } from 'react-icons/fi';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { STATUS_META, formatLiveClassTimeRange } from './live-class-status';

// Card base do calendário semanal (aluno e professor). O que muda por perfil
// entra por props: `onClick` torna o card inteiro clicável, `actions` fica fora
// do conteúdo (pra não aninhar <button> dentro de <button>) e `children`
// aparece no rodapé do card.
export function LiveClassCard({ liveClass, status, onClick, actions, children, testId = 'live-class-card' }) {
  const meta = STATUS_META[status];
  const Content = onClick ? 'button' : 'div';

  return (
    <div
      className="relative"
      data-testid={`${testId}-wrapper`}
      data-title={liveClass.title}
    >
      <Content
        {...(onClick && { type: 'button', onClick })}
        className={cn('flex w-full flex-col gap-2 rounded-2xl border border-neutral-lightest p-3 text-left shadow-card transition-shadow duration-150 hover:shadow-card-hover', status === 'ao-vivo' ? 'bg-[#FFF5CC]' : 'bg-white')}
        data-testid={testId}
        data-title={liveClass.title}
      >
        <Badge
          variant={meta.badgeVariant}
          className="w-fit rounded-[4px] px-1 text-2xs font-extrabold uppercase leading-none tracking-wide"
        >
          {meta.label}
        </Badge>

        <div>
          <h4
            className={cn('mb-0 truncate text-sm font-extrabold text-neutral-900', actions && 'pr-6')}
            title={liveClass.title}
          >
            {liveClass.title}
          </h4>
          {liveClass.courses?.[0]?.name && <p className="mb-0 truncate text-sm text-neutral-dark">{liveClass.courses[0].name}</p>}
        </div>

        <p className="mb-0 flex items-center gap-1 text-xs font-semibold text-neutral-dark">
          <FiClock className="h-3.5 w-3.5 shrink-0" />
          {formatLiveClassTimeRange(liveClass)}
        </p>

        {children}
      </Content>

      {actions}
    </div>
  );
}
